import { dashboardHierarchySelector } from "./dashboardHierarchySelector";
import { RootState } from "../../../store";
import {
  Dashboard,
  DashboardFolder,
} from "../../../../services/cloudchipr.api";

export const dashboardHierarchyDataSelector = (
  state: RootState,
): (Dashboard | DashboardFolder)[] | undefined => {
  return dashboardHierarchySelector(state)?.data;
};
